// src/helpers/pdfLinks.js
export const getPdfDisplayUrl = (url) => {
  if (!url) return url;
  const clean = url.split('?')[0].split('#')[0];
  if (clean.toLowerCase().endsWith('.pdf')) {
    return `${url}/@@display-file/file`;
  }
  return url;
};

export const isPdfUrl = (url) =>
  !!url && url.split('?')[0].split('#')[0].toLowerCase().endsWith('.pdf');
